import * as React from "react";
import { RiUploadCloud2Line, RiDeleteBinLine } from "react-icons/ri";
import { Link } from "react-router-dom";

import Button from "../Button";
import axiosInstance from "../../Api/Axios";

import { FileExtImg } from "../../Functions/files";

import "./Dropzone.scss";

const Dropzone = (props) => {
  const {
    id,
    label,
    hint,
    description,
    required,
    multiple,
    value,
    onChange,
    accept,
    hasError,
    errorMessage,
  } = props;

  const [isDraggingOver, setIsDraggingOver] = React.useState(false);
  const [files, setFiles] = React.useState(value || []);
  const [linkFile, setLinkFile] = React.useState(value || []);

  // React.useEffect(() => {
  //   setFiles(value || []);

  //   axiosInstance
  //     .get(`${process.env.REACT_APP_API_URL}/commitment-file`)
  //     .then((response) => {
  //       setLinkFile(response.data.data.url || "javascript:void(0)");
  //     })
  //     .catch(() => {});
  // }, [value]);

  const inputId = id || `dropzone-${Math.floor(Math.random() * 1000)}`;

  const onDropFiles = (e) => {
    const list = e.target.files ? [...e.target.files] : [];
    setFiles((prev) => (multiple ? [...prev, ...list] : [...list]));
    onChange?.(multiple ? [...files, ...list] : [...list]);
  };

  const removeFile = (index) => {
    const newList = files.filter((_, i) => i !== index);
    setFiles(newList);
    onChange?.(newList);
  };

  return (
    <div className="dropzone-component">
      {label && (
        <label htmlFor={inputId} className="dropzone-component-label">
          {label}
          {required && <span className="text-danger"> *</span>}
        </label>
      )}
      {hint && (
        <>
          <span
            style={{ color: "#b94434" }}
            htmlFor={inputId}
            className="dropzone-component-hint"
          >
            {hint}
          </span>

          {linkFile && (
            <Link to={linkFile} target="_blank" download>
              Télécharger
            </Link>
          )}
        </>
      )}
      {(multiple || (!multiple && files.length === 0)) && (
        <label
          htmlFor={inputId}
          className={`dropzone-component-field ${
            isDraggingOver ? "drag-on" : ""
          } ${hasError ? "has-error" : ""}`}
          dropzone="copy"
          onDragOver={() => setIsDraggingOver(true)}
          onDragLeave={() => setIsDraggingOver(false)}
          onDrop={() => setIsDraggingOver(false)}
        >
          <RiUploadCloud2Line className="icon" />
          {description && <span className="description">{description}</span>}
          <input
            id={inputId}
            type="file"
            accept={accept}
            required={required}
            multiple={multiple}
            onChange={onDropFiles}
          />
        </label>
      )}

      {hasError && errorMessage && (
        <div className="error-message">{errorMessage}</div>
      )}

      {files.length > 0 && (
        <div className={`files-list ${multiple ? "" : "single-file"}`}>
          {files.map((f, i) => {
            const fileName = f.name || f.split("/").pop();

            return (
              <div key={`file-${i}`} className="uploaded-file">
                <span className="name" title={fileName || ""}>
                  {FileExtImg(fileName || "")}{" "}
                  <span className="name-text">{fileName || ""}</span>
                </span>
                <Button
                  size="sm"
                  isIconButton
                  isFullyRounded
                  variant="dark"
                  onClick={() => removeFile(i)}
                >
                  <RiDeleteBinLine />
                </Button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Dropzone;
